import { render, staticRenderFns } from "./BriefSharedResource.vue?vue&type=template&id=256b801c&scoped=true&"
import script from "./BriefSharedResource.vue?vue&type=script&lang=js&"
export * from "./BriefSharedResource.vue?vue&type=script&lang=js&"
import style0 from "./BriefSharedResource.vue?vue&type=style&index=0&id=256b801c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b801c",
  null
  
)

export default component.exports